import { postRawRequest } from '../../httpClient';

export async function backfillClipUrlsApi(dryRun = false): Promise<Response> {
  return postRawRequest({
    path: `/sys/pipeline/backfill-clip-urls${dryRun ? '?dryRun=true' : ''}`,
    options: { timeout: 300_000 },
  });
}
